import { render, staticRenderFns } from "./SectionToggleable.vue?vue&type=template&id=4807447a"
import script from "./SectionToggleable.vue?vue&type=script&lang=js"
export * from "./SectionToggleable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports